import { Delete } from "@mui/icons-material";
import { Divider, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get } from "lodash";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { us_states_options } from "../utils/constants";

const StyledWrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
});

const StyledDiv = styled("div")({
    display: "flex",
    flexDirection: "row",
    gap: "4px",
    flex: 1,
});

const LicenseDetail = (props) => {
    const { element, elementIndex, errors, handleUpdateArrayElement, disableInputs, onDelete } = props;

    return (
        <React.Fragment>
            {disableInputs !== true && (
                <IconButton style={{ margin: 0, minWidth: 0, padding: 0 }} onClick={() => onDelete(elementIndex)}>
                    <Delete />
                </IconButton>
            )}
            <StyledWrapper>
                <StyledDiv>
                    <BSInput
                        id="licenseName"
                        label="LICENSE NAME"
                        placeholder="Enter license name"
                        value={element ? element.licenseName : null}
                        error={get(errors, `licenses.${elementIndex}.licenseName`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)
                        }
                        disabled={disableInputs === true}
                        helperText="Required"
                        errorText="Required"
                        extraFormControlStyles={{ flex: "1 1 0", marginBottom: 0 }}
                    />
                    <BSInput
                        id="licenseNumber"
                        label="LICENSE NUMBER"
                        placeholder="Enter license number"
                        value={element ? element.licenseNumber : null}
                        error={get(errors, `licenses.${elementIndex}.licenseNumber`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)
                        }
                        disabled={disableInputs === true}
                        helperText="Required"
                        errorText="Required"
                        extraFormControlStyles={{ flex: "1 1 0", marginBottom: 0 }}
                    />
                </StyledDiv>
                <StyledDiv>
                    <BSInput
                        id="licenseeName"
                        label="LICENSEE NAME"
                        placeholder="Enter licensee name"
                        value={element ? element.licenseeName : null}
                        error={get(errors, `licenses.${elementIndex}.licenseeName`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)
                        }
                        disabled={disableInputs === true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                    />
                    <BSInput
                        id="licenseType"
                        label="LICENSE TYPE"
                        placeholder="Enter license type"
                        value={element ? element.licenseType : null}
                        error={get(errors, `licenses.${elementIndex}.licenseType`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)
                        }
                        disabled={disableInputs === true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                    />
                </StyledDiv>
            </StyledWrapper>
            <StyledWrapper>
                <StyledDiv>
                    <BSSelect
                        id="licenseStateCode"
                        label="STATE"
                        value={element ? element.licenseStateCode : null}
                        error={get(errors, `licenses.${elementIndex}.licenseStateCode`, null)}
                        options={us_states_options}
                        onChange={(e) =>
                            handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)
                        }
                        disabled={disableInputs === true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                        helperText="Required"
                        errorText="Required"
                    />
                    <BSInput
                        id="expirationDate"
                        label="EXPIRATION DATE (OPTIONAL)"
                        placeholder="Enter expiration date"
                        value={element ? element.expirationDate : null}
                        error={get(errors, `licenses.${elementIndex}.expirationDate`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)
                        }
                        disabled={disableInputs === true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                        type="date"
                    />
                </StyledDiv>
                <BSInput
                    id="licenseUrl"
                    label="LICENSE URL"
                    placeholder="Enter license url"
                    value={element ? element.licenseUrl : null}
                    error={get(errors, `licenses.${elementIndex}.licenseUrl`, null)}
                    onChange={(e) => handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)}
                    disabled={disableInputs === true}
                    extraFormControlStyles={{ flex: "1 1 0", marginBottom: 0 }}
                />
            </StyledWrapper>
            <BSInput
                id="comments"
                label="COMMENTS"
                placeholder="Enter comments"
                value={element ? element.comments : null}
                error={get(errors, `licenses.${elementIndex}.comments`, null)}
                onChange={(e) => handleUpdateArrayElement("licenses", elementIndex, e.target.id, e.target.value)}
                disabled={disableInputs === true}
                multiline
                rows={5}
            />
            <Divider />
            <br />
        </React.Fragment>
    );
};

export default LicenseDetail;
